import { CodegenEndpoint, WorkspacesEndpoint } from "./endpoints";
import { DesignSystemsEndpoint } from "./endpoints/design-system";
import { LiveblocksEndpoint } from "./endpoints/liveblocks";
import { UsersEndpoint } from "./endpoints/users";
import { RequestExecutor } from "./transport/request-executor";
import { ForgesEndpoint } from "./endpoints/forge";

type SupernovaApiClientConfig = {
  host: string;
  accessToken: string;
};

export class SupernovaApiClient {
  readonly users: UsersEndpoint;
  readonly workspaces: WorkspacesEndpoint;
  readonly designSystems: DesignSystemsEndpoint;
  readonly codegen: CodegenEndpoint;
  readonly liveblocks: LiveblocksEndpoint;
  readonly forges: ForgesEndpoint;

  constructor(readonly config: SupernovaApiClientConfig) {
    const requestExecutor = new RequestExecutor({
      host: config.host,
      accessToken: config.accessToken,
    });

    this.users = new UsersEndpoint(requestExecutor);
    this.workspaces = new WorkspacesEndpoint(requestExecutor);
    this.designSystems = new DesignSystemsEndpoint(requestExecutor);
    this.codegen = new CodegenEndpoint(requestExecutor);
    this.liveblocks = new LiveblocksEndpoint(requestExecutor);
    this.forges = new ForgesEndpoint(requestExecutor);
  }
}
